import * as React from 'react';
import _ from 'lodash';
import { FormSection } from '@ane/ui-components/lib/components/FormSection';
import { ResizeGroupAs } from './ResizeGroupAs';
import { Accordion } from '@ane/ui-components';
export const SubClusterListV2 = ({ isReadOnly, subClusterList, onRenderSubCluster, onAddSubCluster, onDeleteSubCluster, }) => {
    return (React.createElement(FormSection, { heading: "Sub-clusters", onRenderHeader: (props, defaultRender) => (React.createElement(ResizeGroupAs, { ariaLabelForGroup: 'Sub-clusters', data: [
                {
                    key: 'addRow',
                    ariaLabel: 'Add sub-cluster',
                    text: 'Add sub-cluster',
                    disabled: !!isReadOnly,
                    iconProps: {
                        iconName: 'Add',
                    },
                    onClick: onAddSubCluster,
                },
            ], onRenderData: ({ primaryItems, overflowItems }, onRenderItem, onRenderOverflowButton) => defaultRender(Object.assign(Object.assign({}, props), { overflowSetProps: {
                    items: primaryItems,
                    overflowItems,
                    onRenderItem: onRenderItem,
                    onRenderOverflowButton,
                } })) })) }, _.map(subClusterList, (item, index) => {
        const groupName = 'Sub-cluster ' + (index + 1);
        return (React.createElement(Accordion, { ariaLabel: groupName, header: groupName, showContentOnRender: !item.collapsed, onRenderHeader: (props, defaultRender) => (React.createElement(ResizeGroupAs, { ariaLabelForGroup: groupName, data: [
                    {
                        key: 'deleteRow',
                        ariaLabel: 'Delete',
                        text: 'Delete',
                        disabled: !!isReadOnly,
                        iconProps: {
                            iconName: 'Delete',
                        },
                        onClick: () => onDeleteSubCluster(index),
                    },
                ], onRenderData: ({ primaryItems, overflowItems }, onRenderItem, onRenderOverflowButton) => defaultRender(Object.assign(Object.assign({}, props), { overflowSetProps: {
                        items: primaryItems,
                        overflowItems,
                        onRenderItem: onRenderItem,
                        onRenderOverflowButton,
                    } })) })) }, onRenderSubCluster({ itemIndex: index })));
    })));
};

//# sourceMappingURL=SubClusterListV2.js.map
